class StickyAddToCart extends HTMLElement {
    constructor() {
        super();
        this.showClass = 'show';
    }

    connectedCallback() {
        const mainCTA = document.querySelector('.product-form__cart-submit');
        if (!mainCTA) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.classList.remove(this.showClass);
                    } else {
                        this.classList.add(this.showClass);
                    }
                });
            },
            { threshold: 0 }
        );

        observer.observe(mainCTA);
    }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);